import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveSectionPath, clearSectionPath } from 'js/actions/app/sectionNavigationActions';
import { SectionKey } from '../types';

type SectionNavigationAdapter = {
  saveSectionPath: (section: SectionKey, path: string) => void;
  clearSectionPath: (section: SectionKey) => void;
};

/**
 * Adapter hook for section navigation actions
 * Dispatches Redux actions (which handle localStorage syncing)
 */
export default function useSectionNavigationAdapter(): SectionNavigationAdapter {
  const dispatch = useDispatch();

  const handleSaveSectionPath = useCallback((section: SectionKey, path: string) => {
    dispatch(saveSectionPath(section, path));
  }, []);

  const handleClearSectionPath = useCallback((section: SectionKey) => {
    dispatch(clearSectionPath(section));
  }, []);

  return {
    saveSectionPath: handleSaveSectionPath,
    clearSectionPath: handleClearSectionPath,
  };
}
